import { Action } from 'redux';
import { AsyncState } from '../../async/state/types';

import { CollectionSyncState, ResultsCollection, SyncState } from '../../sync/state/types';

export type Reducer<State> = (state: State, action: Action) => State;

// Reducers are already self-narrowing, so we can use any for the
// action type here to ease the burden of typing the reducers.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type JoinableReducer<State> = (state: State, action: any) => State;

export function joinReducers<T>(
	reducers: (JoinableReducer<AsyncState<T>> | JoinableReducer<SyncState<T>>)[],
	defaultState: AsyncState<T>
): Reducer<AsyncState<T>> {
	return function(state = defaultState, action) {
		let currentState = state;

		for (let i = 0; i < reducers.length; i++) {
			currentState = reducers[ i ](currentState, action) as AsyncState<T>;
		}

		return currentState;
	};
}

export function joinCollectionReducers<T>(
	reducers: (JoinableReducer<AsyncState<ResultsCollection<T>>> | JoinableReducer<CollectionSyncState<T>>)[],
	defaultState: AsyncState<ResultsCollection<T>>
): Reducer<AsyncState<ResultsCollection<T>>> {
	return function(state = defaultState, action) {
		let currentState = state;

		for (let i = 0; i < reducers.length; i++) {
			currentState = reducers[ i ](currentState, action) as AsyncState<ResultsCollection<T>>;
		}

		return currentState;
	};
}

export function joinSyncCollectionReducers<T>(
	reducers: JoinableReducer<CollectionSyncState<T>>[],
	defaultState: CollectionSyncState<T>
): Reducer<CollectionSyncState<T>> {
	return function(state = defaultState, action) {
		let currentState = state;

		for (let i = 0; i < reducers.length; i++) {
			currentState = reducers[ i ](currentState, action) as CollectionSyncState<T>;
		}

		return currentState;
	};
}

export function joinSyncReducers<T>(
	reducers: JoinableReducer<SyncState<T>>[],
	defaultState: SyncState<T>
): Reducer<SyncState<T>> {
	return function(state = defaultState, action) {
		let currentState = state;

		for (let i = 0; i < reducers.length; i++) {
			currentState = reducers[ i ](currentState, action) as SyncState<T>;
		}

		return currentState;
	};
}
